import { setConfiguration } from '@configuratorware/configurator-frontendgui/App/configuration';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import ConfiguratorScreen from './App/Screens/Configurator/Screen.js';
import VisualizationService from './Services/VisualizationService';
import ConfiguratorReducer from './App/Reducers/Configurator/Reducer';
import ConfiguratorService from './Services/ConfiguratorService';

const prod = process.env.NODE_ENV === 'production';

const envDomains = {
  test: '',
  int: '',
  local: 'http://localhost:10610', //'http://int.gautzsch.local', //
  prod: '',
};

const domain = envDomains[prod ? 'prod' : 'local'];

const query = new URLSearchParams(location.search);

const adminMode = query.get('_adminmode');

const customApplicationConfiguration = {
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}`,
    resourcesURL: `${domain}`,
  },
  optionDetailsWithImage: true,
  dock: 'bottom',
  showStartHere: false,
  screens: {
    Configurator: ConfiguratorScreen,
  },
  services: {
    VisualizationService,
    ConfiguratorService,
  },
  reducers: {
    configurator: ConfiguratorReducer,
  },
  visualization: {
    options3D: {
      useDirectionalLight: true,
    },
  },
};

setConfiguration(customApplicationConfiguration);

if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader('no-cache');
}

export default customApplicationConfiguration;
